import { ColumnsType } from "antd/es/table";
import { EProgramBookingStatus, programBookingStatusToTextMap, statusTagColor, textToProgramBookingStatusMap } from "../../../wellnessProgram/program/booking/model";
import dayjs from "dayjs";
import { Tag } from "antd";
import { useQuery } from "@tanstack/react-query";
import { getAllProgramBookingForCancelManage } from "../../../../service/programBooking";
import { Link } from "react-router-dom";

export interface IProgramBookingForCancelManage {
    id: number;
    memberName: string;
    memberMobile: string;
    programTitle: string;
    targetDateTime: string;
    requestCancelDateTime: string;
    status: string;
}

export type TSearchCategory = 'memberName' | 'memberMobile' | 'programTitle'

const filterStatusOptions = [{ label: '전체', value: 'all' }, { label: programBookingStatusToTextMap[EProgramBookingStatus.COMPLETE], value: EProgramBookingStatus.COMPLETE }, { label: programBookingStatusToTextMap[EProgramBookingStatus.REQUEST_CANCEL], value: EProgramBookingStatus.REQUEST_CANCEL }, { label: programBookingStatusToTextMap[EProgramBookingStatus.CANCEL], value: EProgramBookingStatus.CANCEL }, { label: programBookingStatusToTextMap[EProgramBookingStatus.REFUND], value: EProgramBookingStatus.REFUND }]

const filterCategoryOptions: { label: string, value: TSearchCategory }[] = [{ label: '이름', value: 'memberName' }, { label: '전화번호', value: 'memberMobile' }, { label: '프로그램', value: 'programTitle' }]

const cancelManageColumns: ColumnsType<IProgramBookingForCancelManage> = [
    {
        title: '예약번호',
        dataIndex: 'id'
    },
    {
        title: '이름',
        dataIndex: 'memberName'
    },
    {
        title: '전화번호',
        dataIndex: 'memberMobile'
    },
    {
        title: '프로그램',
        dataIndex: 'programTitle'
    },
    {
        title: '프로그램 이용일',
        dataIndex: 'targetDateTime',
        render: q => <div>{dayjs(q).locale('ko').format('YYYY.MM.DD ddd')}</div>
    },
    {
        title: '취소요청일',
        dataIndex: 'requestCancelDateTime',
        render: q => <div>{dayjs(q).locale('ko').format('YYYY.MM.DD ddd')}</div>
    },
    {
        title: '상태',
        dataIndex: 'status',
        render: (q: EProgramBookingStatus) => <Tag color={statusTagColor(textToProgramBookingStatusMap[q] ?? q)}>{q}</Tag>
    },
    {
        title: '상세',
        dataIndex: 'id',
        render: q => <Link to={`/cancel-manage/detail/${q}`}>상세</Link>
    },
]

const useGetAllProgramBookingForCancelManage = <T,>(statusList: string[], programBookingField?: any) => {
    const query = useQuery({
        queryKey: ['getAllProgramBookingForCancelManage', statusList],
        queryFn: () => getAllProgramBookingForCancelManage<T>(statusList, programBookingField),
        select: (res) => res.data.data.getAllProgramBookingForCancelManage ?? []
    })

    return query;
}

export { filterStatusOptions, filterCategoryOptions, cancelManageColumns, useGetAllProgramBookingForCancelManage }